import { ChevronLeft, ChevronRight } from 'lucide-react';

// THE ROUND ‹ › EVERY PAGER WEARS — sub-steps, steps, runs — so they read as one kind of
// control wherever they are. White in both themes, like the badges (TIP_BADGE): they sit on
// the dark blueprint page either way, and an outline on it let the grid run through them.
export function NavArrow({ dir, onClick, disabled, label, large = false }: {
  dir: 'prev' | 'next';
  onClick: () => void;
  disabled?: boolean;
  label: string;
  // The step skimmer's, a size up: it heads a phase, where the others sit inside one.
  large?: boolean;
}) {
  const Icon = dir === 'prev' ? ChevronLeft : ChevronRight;
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={label}
      className="shrink-0 rounded-full border border-slate-300 bg-white p-2 text-slate-700 shadow-sm transition-colors hover:border-blue-500 hover:text-blue-600 disabled:cursor-default disabled:opacity-30 disabled:hover:border-slate-300 disabled:hover:text-slate-700"
    >
      <Icon className={large ? 'h-5 w-5' : 'h-4 w-4'} />
    </button>
  );
}
